import {
  HStack,
  Icon,
  StackProps,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { RiArrowDownSLine } from "@remixicon/react";
import { lazy, Suspense } from "react";
import { useBgHover, useBorderColor } from "../../themes/colors";
import { CardSkeleton } from "../skeleton/CardSkeleton";

const InputVariantModal = lazy(
  () => import("../../pages/dashboard/supplier/InputVariantModal")
);

interface Props extends StackProps {
  isError: boolean;
}

export const ButtonInput = ({ isError, ...rest }: Props) => {
  const borderColor = useBorderColor();
  const bgHover = useBgHover();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <HStack
        w={"100%"}
        height={"40px"}
        py={2}
        px={4}
        borderRadius={"md"}
        variant={"outline"}
        borderWidth={isError ? "3px" : "1px"}
        borderColor={isError ? "red.400" : borderColor}
        justifyContent={"space-between"}
        onClick={onOpen}
        cursor={"pointer"}
        _hover={{ bg: bgHover }}
        {...rest}
      >
        <Text textStyle={"b-reg"} color={"gray.400"}>
          Tambah Varian
        </Text>

        <Icon as={RiArrowDownSLine} fontSize={[16, null, 18]} />
      </HStack>

      <Suspense fallback={<CardSkeleton row={1} height={40} />}>
        <InputVariantModal
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          children={undefined}
        />
      </Suspense>
    </>
  );
};
